var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEvaluate48Line = function SvgIconEvaluate48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 28.299h-2.1v-14.7c0-2.92-2.38-5.3-5.3-5.3H13.6a5.31 5.31 0 0 0-5.3 5.3v21.9a4.2 4.2 0 0 0 4.2 4.2h23c.12 0 .23-.01.34-.03 2.15-.18 3.86-1.97 3.86-4.17v-4.3c0-1.6-1.3-2.9-2.9-2.9Zm-24.3 8c-.44 0-.8-.36-.8-.8v-21.9c0-1.05.85-1.9 1.9-1.9h15.8c1.05 0 1.9.85 1.9 1.9v21.9c0 .27.03.54.08.8H12.5Zm22.2-.8v-3.8h1.6v3.8c0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.75 25.559-3.01-3.25-2.49 2.31 3.78 4.08c.42.46 1.02.73 1.64.74h.05c.6 0 1.19-.24 1.62-.67l7.35-7.32-2.4-2.41-6.55 6.52h.01Z",
    fill: "current"
  })));
};
export default SvgIconEvaluate48Line;